import { request } from '@/utils/request';

/**
 * 获取关联档口列表
 */
export function getRelatedBooths() {
  return request<API.BoothsItem[]>({
    url: '/seller/erpSellerPool/getList',
    method: 'post',
  });
}

/**
 * 获取备货订单的商品明细（备货统计）
 */
export function getStockUpInfo(data: API.GetStockUpInfoParams) {
  return request<API.GetStockUpInfoResponse>({
    url: '/seller/order/getStockUpInfo',
    method: 'post',
    data,
  });
}
